import { render } from "./CheckboxView.vue?vue&type=template&id=6d4436fa&scoped=true"
import script from "./CheckboxView.vue?vue&type=script&lang=js"
export * from "./CheckboxView.vue?vue&type=script&lang=js"

import "./CheckboxView.vue?vue&type=style&index=0&id=6d4436fa&scoped=true&lang=css"

import exportComponent from "C:\\Work\\huabiao-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4436fa"]])

export default __exports__